module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/VC-f2c13429d171859bab3f8e503b531467.png";